import { render } from "./ConversationsView.vue?vue&type=template&id=54eda900&scoped=true"
import script from "./ConversationsView.vue?vue&type=script&lang=js"
export * from "./ConversationsView.vue?vue&type=script&lang=js"

import "./ConversationsView.vue?vue&type=style&index=0&id=54eda900&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-54eda900"]])

export default __exports__